module.exports = __webpack_public_path__ + "static/media/diagram.a294cecd.webp";